// extracted by mini-css-extract-plugin
module.exports = {"root":"Section_root__VPnuD","label":"Section_label__3CmFK","contentWrap":"Section_contentWrap__e_T5_","footer":"Section_footer__2fZ_U","footerInner":"Section_footerInner__3-rIy"};